import { Card } from "@/components/ui/card";

export const StatCard = ({ label, value, hint, icon: Icon, accent = false, testId }) => {
  return (
    <Card
      className={
        "p-6 border-[#E2E8F0] bg-white transition-all hover:-translate-y-0.5 hover:shadow-md h-full " +
        (accent ? "border-l-4 border-l-[#9DCD3F]" : "")
      }
      data-testid={testId}
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="overline text-[#9DCD3F]">{label}</div>
          <div className="font-display text-3xl mt-2 text-[#1B2C5A] leading-tight">{value}</div>
          {hint && <div className="text-xs text-[#475569] mt-2">{hint}</div>}
        </div>
        {Icon && (
          <div className="w-10 h-10 rounded-lg bg-[#1B2C5A]/5 text-[#1B2C5A] grid place-items-center">
            <Icon className="w-5 h-5" />
          </div>
        )}
      </div>
    </Card>
  );
};

export const PageHeader = ({ overline, title, description, actions, testId }) => (
  <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8" data-testid={testId}>
    <div>
      {overline && <div className="overline text-[#9DCD3F]">{overline}</div>}
      <h1 className="font-display text-3xl text-[#1B2C5A] mt-2 leading-tight">{title}</h1>
      {description && <p className="text-[#475569] mt-2 max-w-2xl">{description}</p>}
    </div>
    {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
  </div>
);

export const EmptyState = ({ message = "No data yet", testId }) => (
  <div className="p-12 text-center text-[#475569] text-sm border border-dashed border-[#E2E8F0] rounded-xl bg-white" data-testid={testId}>
    {message}
  </div>
);
